module.exports = __webpack_public_path__ + "static/media/eventlogo.90698486.png";